import { render, staticRenderFns } from "./kowledgePoints.vue?vue&type=template&id=5e5d2fa7&scoped=true"
import script from "./kowledgePoints.vue?vue&type=script&lang=js"
export * from "./kowledgePoints.vue?vue&type=script&lang=js"
import style0 from "./kowledgePoints.vue?vue&type=style&index=0&id=5e5d2fa7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5d2fa7",
  null
  
)

export default component.exports